export default {
  tr: {
    noenough: 'Slot oynamak için yeterli altının yok',
    later: 'Daha sonra',
    exchange: 'Takas Et',
    close: 'Kapat',
    yes: 'Onayla',
    title: 'Altın Takası',
    desc: 'Altını manuel olarak çıkarmak için Çıkar düğmesine tıkla'
  },
  en: {
    noenough: "You don't have enough coins to play slot",
    later: 'Later',
    exchange: 'Exchange',
    close: 'Close',
    yes: 'Confirm',
    title: 'Gold Exchange',
    desc: 'Click the extract button to manually extract gold'
  },
  ar: {
    noenough: 'ليس لديك ما يكفي من العملات للعب السلوت',
    later: 'لاحقًا',
    exchange: 'استبدال',
    close: 'إغلاق',
    yes: 'تأكيد',
    title: 'تبديل الذهب',
    desc: 'انقر على زر الاستخراج لاستخراج الذهب يدويًا'
  },
  ru: {
    // Russian
    noenough: 'У вас недостаточно монет для игры в слоты',
    later: 'Позже',
    exchange: 'Обмен',
    close: 'Закрыть',
    yes: 'Подтвердить',
    title: 'Обмен золота',
    desc: 'Нажмите кнопку извлечения, чтобы вручную извлечь золото'
  },
  id: {
    // Indonesian
    noenough: 'Anda tidak memiliki cukup koin untuk bermain slot',
    later: 'Nanti',
    exchange: 'Tukar',
    close: 'Tutup',
    yes: 'Konfirmasi',
    title: 'Pertukaran Emas',
    desc: 'Klik tombol ekstrak untuk mengekstrak emas secara manual'
  },
  uz: {
    // Uzbek
    noenough: "Sizda slot o'ynash uchun etarli tanga yo'q",
    later: 'Keyinroq',
    exchange: 'Almashish',
    close: 'Yopish',
    yes: 'Tasdiqlash',
    title: 'Oltin Almashish',
    desc: "Oltinni qo'lda olish uchun ekstrakt tugmasini bosing"
  },
  fa: {
    // Persian
    noenough: 'سکه کافی برای بازی اسلات ندارید',
    later: 'بعداً',
    exchange: 'تبادل',
    close: 'بستن',
    yes: 'تأیید',
    title: 'تبدیل طلا',
    desc: 'برای استخراج دستی طلا روی دکمه استخراج کلیک کنید'
  },
  ur: {
    // Urdu
    noenough: 'آپ کے پاس سلاٹ کھیلنے کے لیے کافی سکے نہیں ہیں',
    later: 'بعد میں',
    exchange: 'تبادلہ',
    close: 'بند کریں',
    yes: 'تصدیق کریں',
    title: 'سونے کا تبادلہ',
    desc: 'سونے کو دستی طور پر نکالنے کے لیے نکالنے کے بٹن پر کلک کریں'
  },
  pt: {
    // Portuguese (Brazil)
    noenough: 'Você não tem moedas suficientes para jogar slots',
    later: 'Depois',
    exchange: 'Trocar',
    close: 'Fechar',
    yes: 'Confirmar',
    title: 'Troca de Ouro',
    desc: 'Clique no botão de extração para extrair ouro manualmente'
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-reyou/lang.js